var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitleIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5889 0C4.58808 0 4.58727 0 4.58645 0C4.30264 0 4.03594 0.11575 3.83442 0.326202C3.63072 0.538929 3.51855 0.822469 3.51855 1.12393V17.9803C3.51855 18.5983 4.00063 19.1025 4.59351 19.1042C7.09243 19.1105 11.2787 19.656 14.1668 22.8207V5.17997C14.1668 4.97037 14.1158 4.77357 14.0194 4.61061C11.6486 0.613726 7.09351 0.00625669 4.5889 0Z",
    fill: "#1882FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.482 17.9806V1.12393C26.482 0.822184 26.3698 0.538929 26.1661 0.326202C25.9646 0.11575 25.6976 0 25.4141 0C25.4133 0 25.4122 0 25.4114 0C22.907 0.00625669 18.3519 0.613723 15.9815 4.61089C15.885 4.77385 15.834 4.97065 15.834 5.18025V22.821C18.7221 19.6562 22.9087 19.1108 25.4073 19.1045C25.9996 19.1028 26.482 18.5986 26.482 17.9806Z",
    fill: "#1882FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9269 3.88745H28.1485V17.9806C28.1485 19.5587 26.9206 20.8459 25.4111 20.8496C23.2916 20.855 19.7968 21.289 17.3218 23.7419C21.6023 22.6444 26.1148 23.358 28.6868 23.9714C29.0078 24.0479 29.3397 23.9689 29.5969 23.7541C29.8533 23.54 30.0002 23.2198 30.0002 22.8762V5.01138C30.0005 4.39168 29.5187 3.88745 28.9269 3.88745Z",
    fill: "#FFBF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85171 17.9806V3.88745H1.07333C0.481533 3.88745 0 4.39168 0 5.01138V22.8762C0 23.22 0.147203 23.54 0.403313 23.7541C0.66051 23.9688 0.991851 24.0482 1.31342 23.9714C3.88511 23.3577 8.39788 22.6441 12.6782 23.7419C10.2031 21.289 6.70831 20.855 4.58881 20.8499C3.07985 20.8459 1.85171 19.559 1.85171 17.9806Z",
    fill: "#FFBF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitleIcon15);
export default __webpack_public_path__ + "static/media/subtitle-icon1-5.c81f3268d6520dd542f8a3f9a298c5bd.svg";
export { ForwardRef as ReactComponent };